export default class NamesManager {
    private addNameBtnClass: string;
    private readonly maxNamesCount = 5;
    private removeNameBtnClass: string;
    private readonly localization: Localization;

    constructor(
        addNameBtnClass: string,
        removeNameBtnClass: string,
        localization: Localization,
    ) {
        this.addNameBtnClass = addNameBtnClass;
        this.removeNameBtnClass = removeNameBtnClass;
        this.localization = localization;
    }

    public init(): void {
        jq(document.documentElement)
            .on("click", `.${this.addNameBtnClass}`, (event) => {
                const clickedButton = jq(event.currentTarget);
                const inputContainer = clickedButton.parents(".name-input-container");
                const nameInputElementJq = inputContainer.find("input");
                const verificationSelectionBlockJq = inputContainer.find(".verification-selection-block");

                const clonedNameInputContainer = inputContainer.clone();
                const clonedNameInputElementJq = clonedNameInputContainer.find("input");

                clonedNameInputElementJq.each((index, element) => {
                    this.resetTextInputValue(element);
                    this.cleanInputElement(element);

                });

                const lastIndex = this.updateNameInputIndex(inputContainer, clonedNameInputContainer);

                if (verificationSelectionBlockJq.length) {
                    const clonedSelectionInputElementJq = clonedNameInputContainer.find("input.confirmation-selection-input");
                    const clonedSelectionInputElement = clonedSelectionInputElementJq.get(0) as HTMLInputElement;

                    this.cleanInputElement(clonedSelectionInputElement);

                    this.updateSelectionBlockIndeces(inputContainer, clonedNameInputContainer);
                }

                clonedNameInputContainer.find(`.${this.addNameBtnClass}`).remove();

                clonedNameInputContainer.insertAfter(inputContainer.parent().children(".name-input-container:last-of-type"));

                this.copyValidationRules(nameInputElementJq, clonedNameInputElementJq);
                this.copyValidationMessageElement(nameInputElementJq, clonedNameInputElementJq);

                if (lastIndex === this.maxNamesCount - 1) {
                    inputContainer.find(`.${this.addNameBtnClass}`).prop("disabled", true);
                }
                this.appendRemoveButton(clonedNameInputContainer);

            })
            .on("click", `.${this.removeNameBtnClass}`, (event) => {
                const clickedButton = jq(event.currentTarget);
                const inputContainer = clickedButton.parents(".name-input-container");
                const inputElementJq = inputContainer.find("input.name");
                this.removeValidationMessageElement(inputElementJq);
                const prevInputContainer = inputContainer.prev(".name-input-container");
                this.updateInputNames(inputContainer);
                inputContainer.remove();
                this.enableAddButton(prevInputContainer);
            });
    }

    private resetTextInputValue(element: HTMLInputElement): void {
        if (element.type !== "checkbox") {
            element.value = "";
        }
        element.checked = false;
    }

    private cleanInputElement(element: HTMLInputElement): void {
        element.removeAttribute("readonly");

        const allowedAttributes = [
            "class",
            "id",
            "name",
            "type",
            "autocomplete",
            "autofocus",
            "disabled",
            "readonly",
            "size",
            "maxlength",
            "step",
            "value",
            "checked",
        ];

        for (let i = element.attributes.length - 1; i >= 0; i--) {
            const attrib = element.attributes[i];
            const attribName = attrib.name;

            if (allowedAttributes.indexOf(attribName) === -1) {
                element.removeAttribute(attribName);
            }
        }
    }

    private copyValidationRules(sourceelement: JQuery, targetElement: JQuery): void {
        const validationRules = sourceelement.rules();

        const formValidationSettings = sourceelement.closest("form").data("validator").settings;
        if (formValidationSettings && formValidationSettings.messages && formValidationSettings.messages[sourceelement.attr("name")]) {
            validationRules.messages = formValidationSettings.messages[sourceelement.attr("name")];
        }

        targetElement.rules("remove");
        targetElement.rules("add", validationRules);
    }

    private copyValidationMessageElement(sourceInputElement: JQuery<HTMLInputElement>, targetInputElement: JQuery<HTMLInputElement>): void {
        const inputName = sourceInputElement.attr("name");
        const validationMessageElement = sourceInputElement.closest("form").find(`*[data-valmsg-for="${inputName}"]`);

        const clonedMessageElement = validationMessageElement.clone();

        const targetInputName = targetInputElement.attr("name");

        clonedMessageElement.attr("data-valmsg-for", targetInputName);

        clonedMessageElement.insertAfter(validationMessageElement);
    }

    private removeValidationMessageElement(inputElement: JQuery<HTMLInputElement>): void {
        const inputName = inputElement.attr("name");
        const validationMessageElement = inputElement.closest("form").find(`*[data-valmsg-for="${inputName}"]`);

        validationMessageElement.remove();
    }

    private appendRemoveButton(
        inputContainer: JQuery,
    ): void {
        const inputButtonsContainer = inputContainer.find(".input-buttons");
        if (!inputContainer.is(":first-of-type") && inputButtonsContainer.find(".remove-name-input-btn").length === 0) {
            this.localization.translateAsync("remove-name", "UserInput").then((value) => {
                const localizedTitle = value.result.value;
                inputButtonsContainer
                    .append(`<button type="button" title="${localizedTitle}" class="btn btn-outline-danger ${this.removeNameBtnClass}"><i class="fas fa-minus fa-lg"></i></button>`);
            });

        }
    }

    private enableAddButton(
        inputContainer: JQuery,
    ): void {
        const firstInput = inputContainer.parent().find(".name-input-container:first-of-type");
        const addButton = firstInput.find(`.${this.addNameBtnClass}`);
        addButton.prop("disabled", false);
    }

    private updateNameInputIndex(prevElement: JQuery, nextElement: JQuery): number {
        const nameInputContainers = prevElement.siblings(".name-input-container").addBack();
        const prevInputIndex = nameInputContainers.last().index();
        const inputIndex = prevInputIndex + 1;

        const inputs = nextElement.find("input");
        inputs.each((index, element) => {
            const inputJq = jq(element);
            const newName = inputJq.attr("name").replace(/\d/g, inputIndex.toString());
            const newId = inputJq.attr("id").replace(/\d/g, inputIndex.toString());
            const inputLabel = inputJq.parent().find("label");
            inputLabel.attr("for", newId);
            inputJq.attr("name", newName);
            inputJq.attr("id", newId);
        });

        return inputIndex;
    }

    private updateSelectionBlockIndeces(prevElement: JQuery, nextElement: JQuery): number {
        const nameInputContainers = prevElement.siblings(".name-input-container").addBack();
        const prevInputIndex = nameInputContainers.last().index();
        const inputIndex = prevInputIndex + 1;

        const input = nextElement.find("input.confirmation-selection-input");
        const label = nextElement.find("label.confirmation-selection-label");
        const newName = input.attr("name").replace(/\d/g, inputIndex.toString());
        const newId = input.attr("id").replace(/\d/g, inputIndex.toString());
        input.attr("name", newName);
        input.attr("id", newId);
        label.attr("for", newId);

        return inputIndex;
    }

    private updateInputNames(inputContainerToBeRemoved: JQuery): void {
        inputContainerToBeRemoved.nextAll().each((index, element) => {
            index = inputContainerToBeRemoved.index() + index;
            const elementJq = jq(element);
            elementJq.find("input").each((inputIndex, inputElement) => {
                const inputJq = jq(inputElement);
                const oldId = inputJq.attr("id");
                const newName = inputJq.attr("name").replace(/\d/g, index.toString());
                const newId = oldId.replace(/\d/g, index.toString());

                inputJq.attr("name", newName);
                inputJq.attr("id", newId);

                elementJq.find(`[for="${oldId}"]`).attr("for", newId);
            });
        });
    }
}
